import { MaintenanceGate } from "@/features/system";
import { Providers } from "./providers";
import { AppRouter } from "./router";

export default function App() {
  return (
    <MaintenanceGate>
      <Providers>
        <AppRouter />
      </Providers>
    </MaintenanceGate>
  );
}
